import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings')({
	component: SettingsLayout,
})

function SettingsLayout() {
	return (
		<div className="flex h-full flex-col overflow-hidden">
			<Outlet />
		</div>
	)
}
